'use strict';


module.exports = [
    {value: 'Africa/Accra', offset: '+00:00'},
    {value: 'Africa/Addis_Ababa', offset: '+03:00', name: 'Africa/Addis Ababa'},
    {value: 'Africa/Algiers', offset: '+01:00'},
    {value: 'Africa/Asmera', offset: '+03:00'},
    {value: 'Africa/Bamako', offset: '+00:00'},
    {value: 'Africa/Bangui', offset: '+01:00'},
    {value: 'Africa/Banjul', offset: '+00:00'},
    {value: 'Africa/Bissau', offset: '+00:00'},
    {value: 'Africa/Blantyre', offset: '+02:00'},
    {value: 'Africa/Brazzaville', offset: '+01:00'},
    {value: 'Africa/Bujumbura', offset: '+02:00'},
    {value: 'Africa/Cairo', offset: '+02:00'},
    {value: 'Africa/Casablanca', offset: '+00:00'},
    {value: 'Africa/Ceuta', offset: '+01:00'},
    {value: 'Africa/Conakry', offset: '+00:00'},
    {value: 'Africa/Dakar', offset: '+00:00'},
    {value: 'Africa/Dar_es_Salaam', offset: '+03:00', name: 'Africa/Dar es Salaam'},
    {value: 'Africa/Djibouti', offset: '+03:00'},
    {value: 'Africa/Douala', offset: '+01:00'},
    {value: 'Africa/El_Aaiun', offset: '+00:00', name: 'Africa/El Aaiun'},
    {value: 'Africa/Freetown', offset: '+00:00'},
    {value: 'Africa/Gaborone', offset: '+02:00'},
    {value: 'Africa/Harare', offset: '+02:00'},
    {value: 'Africa/Johannesburg', offset: '+02:00'},
    {value: 'Africa/Kampala', offset: '+03:00'},
    {value: 'Africa/Khartoum', offset: '+03:00'},
    {value: 'Africa/Kigali', offset: '+02:00'},
    {value: 'Africa/Kinshasa', offset: '+01:00'},
    {value: 'Africa/Lagos', offset: '+01:00'},
    {value: 'Africa/Libreville', offset: '+01:00'},
    {value: 'Africa/Lome', offset: '+00:00'},
    {value: 'Africa/Luanda', offset: '+01:00'},
    {value: 'Africa/Lubumbashi', offset: '+02:00'},
    {value: 'Africa/Lusaka', offset: '+02:00'},
    {value: 'Africa/Malabo', offset: '+01:00'},
    {value: 'Africa/Maputo', offset: '+02:00'},
    {value: 'Africa/Maseru', offset: '+02:00'},
    {value: 'Africa/Mbabane', offset: '+02:00'},
    {value: 'Africa/Mogadishu', offset: '+03:00'},
    {value: 'Africa/Monrovia', offset: '+00:00'},
    {value: 'Africa/Nairobi', offset: '+03:00'},
    {value: 'Africa/Ndjamena', offset: '+01:00'},
    {value: 'Africa/Niamey', offset: '+01:00'},
    {value: 'Africa/Nouakchott', offset: '+00:00'},
    {value: 'Africa/Ouagadougou', offset: '+00:00'},
    {value: 'Africa/Porto-Novo', offset: '+01:00'},
    {value: 'Africa/Sao_Tome', offset: '+00:00', name: 'Africa/Sao Tome'},
    {value: 'Africa/Tripoli', offset: '+02:00'},
    {value: 'Africa/Tunis', offset: '+01:00'},
    {value: 'Africa/Windhoek', offset: '+01:00'},
    {value: 'America/Adak', offset: '-10:00'},
    {value: 'America/Anchorage', offset: '-09:00'},
    {value: 'America/Anguilla', offset: '-04:00'},
    {value: 'America/Antigua', offset: '-04:00'},
    {value: 'America/Araguaina', offset: '-03:00'},
    {value: 'America/Argentina/Buenos_Aires', offset: '-03:00', name: 'America/Argentina/Buenos Aires'},
    {value: 'America/Argentina/Catamarca', offset: '-03:00'},
    {value: 'America/Argentina/Cordoba', offset: '-03:00'},
    {value: 'America/Argentina/Jujuy', offset: '-03:00'},
    {value: 'America/Argentina/La_Rioja', offset: '-03:00', name: 'America/Argentina/La Rioja'},
    {value: 'America/Argentina/Mendoza', offset: '-03:00'},
    {value: 'America/Argentina/Rio_Gallegos', offset: '-03:00', name: 'America/Argentina/Rio Gallegos'},
    {value: 'America/Argentina/San_Juan', offset: '-03:00', name: 'America/Argentina/San Juan'},
    {value: 'America/Argentina/Tucuman', offset: '-03:00'},
    {value: 'America/Argentina/Ushuaia', offset: '-03:00'},
    {value: 'America/Aruba', offset: '-04:00'},
    {value: 'America/Asuncion', offset: '-04:00'},
    {value: 'America/Bahia', offset: '-03:00'},
    {value: 'America/Barbados', offset: '-04:00'},
    {value: 'America/Belem', offset: '-03:00'},
    {value: 'America/Belize', offset: '-06:00'},
    {value: 'America/Boa_Vista', offset: '-04:00', name: 'America/Boa Vista'},
    {value: 'America/Bogota', offset: '-05:00'},
    {value: 'America/Boise', offset: '-07:00'},
    {value: 'America/Cambridge_Bay', offset: '-07:00', name: 'America/Cambridge Bay'},
    {value: 'America/Campo_Grande', offset: '-04:00', name: 'America/Campo Grande'},
    {value: 'America/Cancun', offset: '-06:00'},
    {value: 'America/Caracas', offset: '-04:30'},
    {value: 'America/Cayenne', offset: '-03:00'},
    {value: 'America/Cayman', offset: '-05:00'},
    {value: 'America/Chicago', offset: '-06:00'},
    {value: 'America/Chihuahua', offset: '-07:00'},
    {value: 'America/Coral_Harbour', offset: '-05:00', name: 'America/Coral Harbour'},
    {value: 'America/Costa_Rica', offset: '-06:00', name: 'America/Costa Rica'},
    {value: 'America/Cuiaba', offset: '-04:00'},
    {value: 'America/Curacao', offset: '-04:00'},
    {value: 'America/Danmarkshavn', offset: '+00:00'},
    {value: 'America/Dawson', offset: '-08:00'},
    {value: 'America/Dawson_Creek', offset: '-07:00', name: 'America/Dawson Creek'},
    {value: 'America/Denver', offset: '-07:00'},
    {value: 'America/Detroit', offset: '-05:00'},
    {value: 'America/Dominica', offset: '-04:00'},
    {value: 'America/Edmonton', offset: '-07:00'},
    {value: 'America/Eirunepe', offset: '-04:00'},
    {value: 'America/El_Salvador', offset: '-06:00', name: 'America/El Salvador'},
    {value: 'America/Fortaleza', offset: '-03:00'},
    {value: 'America/Glace_Bay', offset: '-04:00', name: 'America/Glace Bay'},
    {value: 'America/Godthab', offset: '-03:00'},
    {value: 'America/Goose_Bay', offset: '-04:00', name: 'America/Goose Bay'},
    {value: 'America/Grand_Turk', offset: '-05:00', name: 'America/Grand Turk'},
    {value: 'America/Grenada', offset: '-04:00'},
    {value: 'America/Guadeloupe', offset: '-04:00'},
    {value: 'America/Guatemala', offset: '-06:00'},
    {value: 'America/Guayaquil', offset: '-05:00'},
    {value: 'America/Guyana', offset: '-04:00'},
    {value: 'America/Halifax', offset: '-04:00'},
    {value: 'America/Havana', offset: '-05:00'},
    {value: 'America/Hermosillo', offset: '-07:00'},
    {value: 'America/Indiana/Indianapolis', offset: '-05:00'},
    {value: 'America/Indiana/Knox', offset: '-06:00'},
    {value: 'America/Indiana/Marengo', offset: '-05:00'},
    {value: 'America/Indiana/Petersburg', offset: '-05:00'},
    {value: 'America/Indiana/Vevay', offset: '-05:00'},
    {value: 'America/Indiana/Vincennes', offset: '-05:00'},
    {value: 'America/Inuvik', offset: '-07:00'},
    {value: 'America/Iqaluit', offset: '-05:00'},
    {value: 'America/Juneau', offset: '-09:00'},
    {value: 'America/Kentucky/Louisville', offset: '-05:00'},
    {value: 'America/Kentucky/Monticello', offset: '-05:00'},
    {value: 'America/La_Paz', offset: '-04:00', name: 'America/La Paz'},
    {value: 'America/Lima', offset: '-05:00'},
    {value: 'America/Los_Angeles', offset: '-08:00', name: 'America/Los Angeles'},
    {value: 'America/Maceio', offset: '-03:00'},
    {value: 'America/Managua', offset: '-06:00'},
    {value: 'America/Manaus', offset: '-04:00'},
    {value: 'America/Martinique', offset: '-04:00'},
    {value: 'America/Mazatlan', offset: '-07:00'},
    {value: 'America/Menominee', offset: '-06:00'},
    {value: 'America/Merida', offset: '-06:00'},
    {value: 'America/Mexico_City', offset: '-06:00', name: 'America/Mexico City'},
    {value: 'America/Miquelon', offset: '-03:00'},
    {value: 'America/Moncton', offset: '-04:00'},
    {value: 'America/Monterrey', offset: '-06:00'},
    {value: 'America/Montevideo', offset: '-03:00'},
    {value: 'America/Montreal', offset: '-05:00'},
    {value: 'America/Montserrat', offset: '-04:00'},
    {value: 'America/Nassau', offset: '-05:00'},
    {value: 'America/New_York', offset: '-05:00', name: 'America/New York'},
    {value: 'America/Nipigon', offset: '-05:00'},
    {value: 'America/Nome', offset: '-09:00'},
    {value: 'America/Noronha', offset: '-02:00'},
    {value: 'America/North_Dakota/Center', offset: '-06:00', name: 'America/North Dakota/Center'},
    {value: 'America/Panama', offset: '-05:00'},
    {value: 'America/Pangnirtung', offset: '-05:00'},
    {value: 'America/Paramaribo', offset: '-03:00'},
    {value: 'America/Phoenix', offset: '-07:00'},
    {value: 'America/Port-au-Prince', offset: '-05:00'},
    {value: 'America/Port_of_Spain', offset: '-04:00', name: 'America/Port of Spain'},
    {value: 'America/Porto_Velho', offset: '-04:00', name: 'America/Porto Velho'},
    {value: 'America/Puerto_Rico', offset: '-04:00', name: 'America/Puerto Rico'},
    {value: 'America/Rainy_River', offset: '-06:00', name: 'America/Rainy River'},
    {value: 'America/Rankin_Inlet', offset: '-06:00', name: 'America/Rankin Inlet'},
    {value: 'America/Recife', offset: '-03:00'},
    {value: 'America/Regina', offset: '-06:00'},
    {value: 'America/Rio_Branco', offset: '-05:00', name: 'America/Rio Branco'},
    {value: 'America/Santiago', offset: '-04:00'},
    {value: 'America/Santo_Domingo', offset: '-04:00', name: 'America/Santo Domingo'},
    {value: 'America/Sao_Paulo', offset: '-03:00', name: 'America/Sao Paulo'},
    {value: 'America/Scoresbysund', offset: '-01:00'},
    {value: 'America/Shiprock', offset: '-07:00'},
    {value: 'America/Swift_Current', offset: '-06:00', name: 'America/Swift Current'},
    {value: 'America/Tegucigalpa', offset: '-06:00'},
    {value: 'America/Thule', offset: '-04:00'},
    {value: 'America/Thunder_Bay', offset: '-05:00', name: 'America/Thunder Bay'},
    {value: 'America/Tijuana', offset: '-08:00'},
    {value: 'America/Toronto', offset: '-05:00'},
    {value: 'America/Tortola', offset: '-04:00'},
    {value: 'America/Vancouver', offset: '-08:00'},
    {value: 'America/Whitehorse', offset: '-08:00'},
    {value: 'America/Winnipeg', offset: '-06:00'},
    {value: 'America/Yakutat', offset: '-09:00'},
    {value: 'America/Yellowknife', offset: '-07:00'},
    {value: 'Antarctica/Casey', offset: '+11:00'},
    {value: 'Antarctica/Davis', offset: '+07:00'},
    {value: 'Antarctica/DumontDUrville', offset: '+10:00'},
    {value: 'Antarctica/Mawson', offset: '+05:00'},
    {value: 'Antarctica/McMurdo', offset: '+12:00'},
    {value: 'Antarctica/Palmer', offset: '-04:00'},
    {value: 'Antarctica/Rothera', offset: '-03:00'},
    {value: 'Antarctica/South_Pole', offset: '+12:00', name: 'Antarctica/South Pole'},
    {value: 'Antarctica/Syowa', offset: '+03:00'},
    {value: 'Antarctica/Vostok', offset: '+06:00'},
    {value: 'Arctic/Longyearbyen', offset: '+01:00'},
    {value: 'Asia/Aden', offset: '+03:00'},
    {value: 'Asia/Almaty', offset: '+06:00'},
    {value: 'Asia/Amman', offset: '+02:00'},
    {value: 'Asia/Anadyr', offset: '+12:00'},
    {value: 'Asia/Aqtau', offset: '+05:00'},
    {value: 'Asia/Aqtobe', offset: '+05:00'},
    {value: 'Asia/Ashgabat', offset: '+05:00'},
    {value: 'Asia/Ashkhabad', offset: '+05:00'},
    {value: 'Asia/Baghdad', offset: '+03:00'},
    {value: 'Asia/Bahrain', offset: '+03:00'},
    {value: 'Asia/Baku', offset: '+04:00'},
    {value: 'Asia/Bangkok', offset: '+07:00'},
    {value: 'Asia/Beirut', offset: '+02:00'},
    {value: 'Asia/Bishkek', offset: '+06:00'},
    {value: 'Asia/Brunei', offset: '+08:00'},
    {value: 'Asia/Calcutta', offset: '+05:30'},
    {value: 'Asia/Choibalsan', offset: '+08:00'},
    {value: 'Asia/Chongqing', offset: '+08:00'},
    {value: 'Asia/Colombo', offset: '+05:30'},
    {value: 'Asia/Damascus', offset: '+02:00'},
    {value: 'Asia/Dhaka', offset: '+06:00'},
    {value: 'Asia/Dili', offset: '+09:00'},
    {value: 'Asia/Dubai', offset: '+04:00'},
    {value: 'Asia/Dushanbe', offset: '+05:00'},
    {value: 'Asia/Gaza', offset: '+02:00'},
    {value: 'Asia/Harbin', offset: '+08:00'},
    {value: 'Asia/Ho_Chi_Minh', offset: '+07:00', name: 'Asia/Ho Chi Minh'},
    {value: 'Asia/Hong_Kong', offset: '+08:00', name: 'Asia/Hong Kong'},
    {value: 'Asia/Hovd', offset: '+07:00'},
    {value: 'Asia/Irkutsk', offset: '+09:00'},
    {value: 'Asia/Istanbul', offset: '+02:00'},
    {value: 'Asia/Jakarta', offset: '+07:00'},
    {value: 'Asia/Jayapura', offset: '+09:00'},
    {value: 'Asia/Jerusalem', offset: '+02:00'},
    {value: 'Asia/Kabul', offset: '+04:30'},
    {value: 'Asia/Kamchatka', offset: '+12:00'},
    {value: 'Asia/Karachi', offset: '+05:00'},
    {value: 'Asia/Kashgar', offset: '+08:00'},
    {value: 'Asia/Katmandu', offset: '+05:45'},
    {value: 'Asia/Krasnoyarsk', offset: '+08:00'},
    {value: 'Asia/Kuala_Lumpur', offset: '+08:00', name: 'Asia/Kuala Lumpur'},
    {value: 'Asia/Kuching', offset: '+08:00'},
    {value: 'Asia/Kuwait', offset: '+03:00'},
    {value: 'Asia/Macau', offset: '+08:00'},
    {value: 'Asia/Magadan', offset: '+12:00'},
    {value: 'Asia/Makassar', offset: '+08:00'},
    {value: 'Asia/Manila', offset: '+08:00'},
    {value: 'Asia/Muscat', offset: '+04:00'},
    {value: 'Asia/Nicosia', offset: '+02:00'},
    {value: 'Asia/Novokuznetsk', offset: '+07:00'},
    {value: 'Asia/Novosibirsk', offset: '+07:00'},
    {value: 'Asia/Omsk', offset: '+07:00'},
    {value: 'Asia/Oral', offset: '+05:00'},
    {value: 'Asia/Phnom_Penh', offset: '+07:00', name: 'Asia/Phnom Penh'},
    {value: 'Asia/Pontianak', offset: '+07:00'},
    {value: 'Asia/Pyongyang', offset: '+09:00'},
    {value: 'Asia/Qatar', offset: '+03:00'},
    {value: 'Asia/Qyzylorda', offset: '+06:00'},
    {value: 'Asia/Rangoon', offset: '+06:30'},
    {value: 'Asia/Riyadh', offset: '+03:00'},
    {value: 'Asia/Saigon', offset: '+07:00'},
    {value: 'Asia/Sakhalin', offset: '+11:00'},
    {value: 'Asia/Samarkand', offset: '+05:00'},
    {value: 'Asia/Seoul', offset: '+09:00'},
    {value: 'Asia/Shanghai', offset: '+08:00'},
    {value: 'Asia/Taipei', offset: '+08:00'},
    {value: 'Asia/Tashkent', offset: '+05:00'},
    {value: 'Asia/Tbilisi', offset: '+04:00'},
    {value: 'Asia/Tehran', offset: '+03:30'},
    {value: 'Asia/Thimphu', offset: '+06:00'},
    {value: 'Asia/Tokyo', offset: '+09:00'},
    {value: 'Asia/Ulaanbaatar', offset: '+08:00'},
    {value: 'Asia/Urumqi', offset: '+08:00'},
    {value: 'Asia/Vientiane', offset: '+07:00'},
    {value: 'Asia/Vladivostok', offset: '+11:00'},
    {value: 'Asia/Yakutsk', offset: '+10:00'},
    {value: 'Asia/Yekaterinburg', offset: '+06:00'},
    {value: 'Asia/Yerevan', offset: '+04:00'},
    {value: 'Atlantic/Azores', offset: '-01:00'},
    {value: 'Atlantic/Bermuda', offset: '-04:00'},
    {value: 'Atlantic/Canary', offset: '+00:00'},
    {value: 'Atlantic/Cape_Verde', offset: '-01:00', name: 'Atlantic/Cape Verde'},
    {value: 'Atlantic/Faeroe', offset: '+00:00'},
    {value: 'Atlantic/Jan_Mayen', offset: '+01:00', name: 'Atlantic/Jan Mayen'},
    {value: 'Atlantic/Madeira', offset: '+00:00'},
    {value: 'Atlantic/Reykjavik', offset: '+00:00'},
    {value: 'Atlantic/South_Georgia', offset: '-02:00', name: 'Atlantic/South Georgia'},
    {value: 'Atlantic/Stanley', offset: '-03:00'},
    {value: 'Australia/Adelaide', offset: '+09:30'},
    {value: 'Australia/Brisbane', offset: '+10:00'},
    {value: 'Australia/Broken_Hill', offset: '+09:30', name: 'Australia/Broken Hill'},
    {value: 'Australia/Currie', offset: '+10:00'},
    {value: 'Australia/Darwin', offset: '+09:30'},
    {value: 'Australia/Hobart', offset: '+10:00'},
    {value: 'Australia/Lindeman', offset: '+10:00'},
    {value: 'Australia/Lord_Howe', offset: '+10:30', name: 'Australia/Lord Howe'},
    {value: 'Australia/Melbourne', offset: '+10:00'},
    {value: 'Australia/Perth', offset: '+08:00'},
    {value: 'Australia/Sydney', offset: '+10:00'},
    {value: 'Europe/Amsterdam', offset: '+01:00'},
    {value: 'Europe/Andorra', offset: '+01:00'},
    {value: 'Europe/Athens', offset: '+02:00'},
    {value: 'Europe/Belfast', offset: '+00:00'},
    {value: 'Europe/Belgrade', offset: '+01:00'},
    {value: 'Europe/Berlin', offset: '+01:00'},
    {value: 'Europe/Bratislava', offset: '+01:00'},
    {value: 'Europe/Brussels', offset: '+01:00'},
    {value: 'Europe/Bucharest', offset: '+02:00'},
    {value: 'Europe/Budapest', offset: '+01:00'},
    {value: 'Europe/Chisinau', offset: '+02:00'},
    {value: 'Europe/Copenhagen', offset: '+01:00'},
    {value: 'Europe/Dublin', offset: '+00:00'},
    {value: 'Europe/Gibraltar', offset: '+01:00'},
    {value: 'Europe/Guernsey', offset: '+00:00'},
    {value: 'Europe/Helsinki', offset: '+02:00'},
    {value: 'Europe/Isle_of_Man', offset: '+00:00', name: 'Europe/Isle of Man'},
    {value: 'Europe/Istanbul', offset: '+02:00'},
    {value: 'Europe/Jersey', offset: '+00:00'},
    {value: 'Europe/Kaliningrad', offset: '+03:00'},
    {value: 'Europe/Kiev', offset: '+02:00'},
    {value: 'Europe/Lisbon', offset: '+00:00'},
    {value: 'Europe/Ljubljana', offset: '+01:00'},
    {value: 'Europe/London', offset: '+00:00'},
    {value: 'Europe/Luxembourg', offset: '+01:00'},
    {value: 'Europe/Madrid', offset: '+01:00'},
    {value: 'Europe/Malta', offset: '+01:00'},
    {value: 'Europe/Mariehamn', offset: '+02:00'},
    {value: 'Europe/Minsk', offset: '+03:00'},
    {value: 'Europe/Monaco', offset: '+01:00'},
    {value: 'Europe/Moscow', offset: '+03:00'},
    {value: 'Europe/Nicosia', offset: '+02:00'},
    {value: 'Europe/Oslo', offset: '+01:00'},
    {value: 'Europe/Paris', offset: '+01:00'},
    {value: 'Europe/Podgorica', offset: '+01:00'},
    {value: 'Europe/Prague', offset: '+01:00'},
    {value: 'Europe/Riga', offset: '+02:00'},
    {value: 'Europe/Rome', offset: '+01:00'},
    {value: 'Europe/Samara', offset: '+04:00'},
    {value: 'Europe/San_Marino', offset: '+01:00', name: 'Europe/San Marino'},
    {value: 'Europe/Sarajevo', offset: '+01:00'},
    {value: 'Europe/Simferopol', offset: '+02:00'},
    {value: 'Europe/Skopje', offset: '+01:00'},
    {value: 'Europe/Sofia', offset: '+02:00'},
    {value: 'Europe/Stockholm', offset: '+01:00'},
    {value: 'Europe/Tallinn', offset: '+02:00'},
    {value: 'Europe/Tirane', offset: '+01:00'},
    {value: 'Europe/Tiraspol', offset: '+02:00'},
    {value: 'Europe/Uzhgorod', offset: '+02:00'},
    {value: 'Europe/Vaduz', offset: '+01:00'},
    {value: 'Europe/Vatican', offset: '+01:00'},
    {value: 'Europe/Vienna', offset: '+01:00'},
    {value: 'Europe/Vilnius', offset: '+02:00'},
    {value: 'Europe/Volgograd', offset: '+04:00'},
    {value: 'Europe/Warsaw', offset: '+01:00'},
    {value: 'Europe/Zagreb', offset: '+01:00'},
    {value: 'Europe/Zaporozhye', offset: '+02:00'},
    {value: 'Europe/Zurich', offset: '+01:00'},
    {value: 'Indian/Antananarivo', offset: '+03:00'},
    {value: 'Indian/Chagos', offset: '+06:00'},
    {value: 'Indian/Christmas', offset: '+07:00'},
    {value: 'Indian/Cocos', offset: '+06:30'},
    {value: 'Indian/Comoro', offset: '+03:00'},
    {value: 'Indian/Kerguelen', offset: '+05:00'},
    {value: 'Indian/Mahe', offset: '+04:00'},
    {value: 'Indian/Maldives', offset: '+05:00'},
    {value: 'Indian/Mauritius', offset: '+04:00'},
    {value: 'Indian/Mayotte', offset: '+03:00'},
    {value: 'Indian/Reunion', offset: '+04:00'},
    {value: 'Pacific/Apia', offset: '+13:00'},
    {value: 'Pacific/Auckland', offset: '+12:00'},
    {value: 'Pacific/Chatham', offset: '+12:45'},
    {value: 'Pacific/Easter', offset: '-06:00'},
    {value: 'Pacific/Efate', offset: '+11:00'},
    {value: 'Pacific/Enderbury', offset: '+13:00'},
    {value: 'Pacific/Fakaofo', offset: '+13:00'},
    {value: 'Pacific/Fiji', offset: '+12:00'},
    {value: 'Pacific/Funafuti', offset: '+12:00'},
    {value: 'Pacific/Galapagos', offset: '-06:00'},
    {value: 'Pacific/Gambier', offset: '-09:00'},
    {value: 'Pacific/Guadalcanal', offset: '+11:00'},
    {value: 'Pacific/Guam', offset: '+10:00'},
    {value: 'Pacific/Honolulu', offset: '-10:00'},
    {value: 'Pacific/Johnston', offset: '-10:00'},
    {value: 'Pacific/Kiritimati', offset: '+14:00'},
    {value: 'Pacific/Kosrae', offset: '+11:00'},
    {value: 'Pacific/Kwajalein', offset: '+12:00'},
    {value: 'Pacific/Majuro', offset: '+12:00'},
    {value: 'Pacific/Marquesas', offset: '-09:30'},
    {value: 'Pacific/Midway', offset: '-11:00'},
    {value: 'Pacific/Nauru', offset: '+12:00'},
    {value: 'Pacific/Niue', offset: '-11:00'},
    {value: 'Pacific/Norfolk', offset: '+11:30'},
    {value: 'Pacific/Noumea', offset: '+11:00'},
    {value: 'Pacific/Pago_Pago', offset: '-11:00', name: 'Pacific/Pago Pago'},
    {value: 'Pacific/Palau', offset: '+09:00'},
    {value: 'Pacific/Pitcairn', offset: '-08:00'},
    {value: 'Pacific/Ponape', offset: '+11:00'},
    {value: 'Pacific/Port_Moresby', offset: '+10:00', name: 'Pacific/Port Moresby'},
    {value: 'Pacific/Rarotonga', offset: '-10:00'},
    {value: 'Pacific/Saipan', offset: '+10:00'},
    {value: 'Pacific/Tahiti', offset: '-10:00'},
    {value: 'Pacific/Tarawa', offset: '+12:00'},
    {value: 'Pacific/Tongatapu', offset: '+13:00'},
    {value: 'Pacific/Truk', offset: '+10:00'},
    {value: 'Pacific/Wake', offset: '+12:00'},
    {value: 'Pacific/Wallis', offset: '+12:00'}
];
